// Derives distinct activity and student counts from a list of selected grid
// cells. Each cell carries activityId and encryptedUserProfileId.
export default function summarizeAssignments(list) {
  const items = list || [];
  const activityIds = new Set();
  const studentIds = new Set();

  items.forEach((item) => {
    if (item.activityId !== undefined && item.activityId !== null) {
      activityIds.add(item.activityId);
    }
    if (item.encryptedUserProfileId) {
      studentIds.add(item.encryptedUserProfileId);
    }
  });

  return {
    activityCount: activityIds.size || items.length,
    studentCount: studentIds.size
  };
}



// WEBPACK FOOTER //
// ./analytics/assignment-summary.js